import FormHelperText from '@mui/material/FormHelperText'
import LevelPicker from 'Components/reusable/InputFields/LevelPicker'
import { useContext } from 'react'
import { ISkillLevel, ILevel } from 'types/levelItemInterfaces'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Checkbox / switch field.
 */
export const DataEditContextSkillLevelField = <T extends AnyObject>({
  field,
  ...rest
}: {
  field: EditableFieldsOfType<T, ISkillLevel | null>
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, errors, disabled, setFields } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: ILevel | null) => {
    setFields({ [field]: newValue as unknown as ISkillLevel })
  }

  const value = flatData[field] as unknown as ILevel
  const error = errors[field]

  return (
    <>
      <LevelPicker kind="skill" value={value} disabled={disabled[field]} onChange={handleChange} {...rest} />
      {error && <FormHelperText>{error}</FormHelperText>}
    </>
  )
}

/**
 * Language level picker.
 */
